<div class="profile_picture" [style.background-image]="'url(' + profile_picture_url + ')'" [routerLink]="['/settings']"></div>
